package com.fireavert.events.events_happening_now.data_models

import com.fireavert.devices.data_models.data_model.DeviceType
import com.fireavert.devices.data_models.data_model.FireAvertStatus
import com.fireavert.events.shared.data_models.models.EventType
import kotlinx.datetime.Instant

data class ActiveDeviceEvent(
    val id: Long,
    val deviceId: Int,
    val timestamp: Instant,
    val unit: String,
    val unitId: Int,
    val eventType: EventType,
    val alarmActive: Boolean,
    val deviceTriggered: Boolean,
    val deviceOffline: Boolean,
    val fireAvertStatus: FireAvertStatus,
    val alarmEvents: Int,
    val shutoffEvents: Int,
    val deviceType: DeviceType,
    val timezoneId: String,
)